const model = {
  number: {
    name: "№ к/о",
    sex: 1,
    required: true,
    checkLength: true,
    min: 1,
    max: 5,
    isNumber: true,
    isNumberInteger: true
  },
  sum: {
    name: "сумма",
    sex: 2,
    required: true,
    checkLength: false,
    isNumber: true
  },
  reason: {
    name: "основание",
    sex: 0,
    required: true,
    checkLength: false
  },
  created_at: {
    name: "Дата создания",
    sex: 2,
    required: true,
    checkLength: true,
    min: 10,
    max: 10,
    isNumber: false
  },
  updated_at: {
    name: "Дата обновления",
    sex: 2,
    required: true,
    checkLength: true,
    min: 10,
    max: 10,
    isNumber: false
  }
};

module.exports = model;
